import { flashLogActionNames } from './types';
import FlashLogReports from '../../services/flash-log-reports';
import { AppThunkDispatch, AppState } from '..';
import { GetExportFlashLogReport, GetFlashLogReports } from '../../services/types';
import { enqueueSnackbarAction } from '../snackbar/actions';
import { downloadFromUrl } from '../../globals/utils';

export const getFlashLogSummariesAction =
  (input: GetFlashLogReports) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { envVariables, client },
    } = getState();
    const flashLogSummaries = new FlashLogReports(client, envVariables.flashLogsV1);
    dispatch({ type: flashLogActionNames.SET_IS_LOADING, payload: true });
    const response = await flashLogSummaries.getFlashLogSummaries(input);
    dispatch({
      type: flashLogActionNames.SET_FLASH_LOG_SUMMARIES,
      payload: response.data.flashLogStatuses,
    });
    dispatch({ type: flashLogActionNames.SET_IS_LOADING, payload: false });
  };

export const getFlashLogExport =
  (input: GetExportFlashLogReport, setLoading: Function ) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { envVariables, client },
    } = getState();
    try {
      const flashLog = new FlashLogReports(
        client,
        envVariables.flashLogsV1,
        envVariables.storageV1BaseUrl,
      );
      dispatch(
        enqueueSnackbarAction({
          message: 'Flashlog Report CSV export initiated',
          options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
        }),
      );
      const response = await flashLog.exportFlashLog(input, setLoading).then((url: any) => url);
      if (!response) {
        dispatch(
          enqueueSnackbarAction({
            message: 'Flashlog Report CSV export failed',
            options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
          }),
        );
      } else {
        downloadFromUrl(response);

        dispatch(
          enqueueSnackbarAction({
            message: 'Flashlog Report CSV exported successfully',
            options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
          }),
        );
      }
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Flashlog Report CSV export failed',
          options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
        }),
      );
    }
  };
